<template>
  <main v-if="loaded" class="minhaconta__body">
    <h3 class="modal-title h3">Estamos tristes que você esteja indo embora :(</h3>

      <p>Nos preocupamos muito com a satisfação dos nossos clientes e sua experiência em nossa plataforma. Buscamos constantemente por melhorias e, por isso, gostaríamos de entender a razão do seu cancelamento.</p>
      <p>Convidamos você a selecionar abaixo a opção que mais se aproxima do motivo pelo qual vai cancelar sua conta no Dr. Conecta:</p>

      <dr-field
        :field="form.reason"
      />
      <textarea
        id="other_reasons"
        class="form-input !w-1/2  mobile:!w-10/12 mx-4"
        v-model="otherReasons"
        v-if="otherId === form.reason.value"
        placeholder="Escreva o motivo aqui (opcional)"
        rows="4"></textarea>
      <br />

      <p class="text-base">
        Cancelar sua conta removerá todos os seus dados da nossa plataforma, incluindo seu histórico de consultas, consultórios, fichas de pacientes e arquivos anexados. Esta é uma ação irreversível.
      </p>
      <p class="text-base text-grayMedium">Para prosseguir com o cancelamento, digite sua senha no campo abaixo e clique em Cancelar Conta.</p>
      <dr-field
        class="mb-6"
        :validators.sync="$v.form.password"
        :field="form.password"
        :apiErrors.sync="apiErrors.password"
        :showPasswordIcon="form.password.showPassword"
      />
      <footer class="modal-footer mt-4">
        <div class="d-flex flex-space_between mobile:justify-center flex-wrap">
          <button
            @click="$router.replace('/doctor/')"
            class="btn btn-primary mobile:mb-4"
          >
            Quero permanecer no Dr Conecta
          </button>

          <drSubmit
            @click="submit()"
            text="CANCELAR CONTA"
            :sending="sending"
            :disabled="$v.$invalid"
            color="red" />
        </div>
      </footer>
  </main>
</template>

<script>
import {required} from 'vuelidate/lib/validators'
import field from '@/components/form/field'
import submit from '@/components/form/submit'

export default {
  props: [
    'title',
    'body',
    'footer',
    'active',
    'size',
    'confirmText',
    'beforeClose',
    'callback',
    'cancelText'
  ],
  components: {
    drField: field,
    drSubmit: submit
  },
  data () {
    return {
      loaded: false,
      sending: false,
      otherId: null,
      otherReasons: null,
      form: {
        reason: {
          size: 0,
          type: 'radio',
          name: 'reason',
          label: '',
          listClass: 'd-block',
          value: null,
          radios: [],
          showPassword: true,
          errors: {
            required: ' '
          }
        },
        password: {
          size: 3,
          type: 'password',
          name: 'password',
          label: 'Senha',
          value: null,
          showPassword: true,
          errors: {
            required: ' '
          }
        }
      },
      apiErrors: {
        password: []
      }
    }
  },
  validations: {
    form: {
      password: {
        value: {
          required
        }
      }
    }
  },
  watch: {
    'form.reason.value': function (next) {
      if (next === this.otherId) {
        this.$nextTick(() => {
          document.getElementById('other_reasons').focus()
        })
      }
    }
  },
  mounted () {
    this.loaded = false
    this.sending = false
    this.$http.get('/doctor_cancellation_reason', this.$store.getters.getAuthHeader).then(
      res => {
        this.loaded = true
        for (let el of res.data.data) {
          this.form.reason.radios.push(
            {
              value: el.id,
              label: el.name
            }
          )
          if (el.name.search(/outra/g)) {
            this.otherId = el.id
          }
        }
      }
    ).catch(
      err => {
        console.log(err)
      }
    ).finally(
      () => {
        this.fn_HIDE_PROGRESS()
      }
    )
  },
  methods: {
    close () {
      this.$router.go(-1)
    },
    submit () {
      if (this.$v.$invalid) {
        return
      }
      this.apiErrors.password = []

      const data = {
        _username: this.$store.getters.getUser,
        _password: this.form.password.value
      }
      const form = {
        doctorCancellationReason: this.form.reason.value,
        complement: this.otherReasons
      }

      this.sending = true
      this.fn_SHOW_PROGRESS()
      this.$http
        .post('/login_check', data, {headers: { ...this.$store.getters.getAuthHeader.headers, 'Accept-Language': 'cancelAccount' }})
        .then((res) => {
          this.$http.post('/doctor/doctor_cancellation', {doctor_cancellation: form}, this.$store.getters.getAuthHeader).then(
            (res) => {
              this.$router.push({path: '/'})
              this.$store.dispatch('setModalAlert', {
                title: 'Sucesso',
                body: 'Sua conta foi cancelada com sucesso!',
                size: 'md',
                active: true
              })
            }
          ).catch(err => console.log(err))
        }).catch(
          err => {
            console.log(err)
            this.apiErrors.password = ['Senha incorreta']
            this.sending = false
            this.fn_HIDE_PROGRESS()
          }
        )
    }
  }
}
</script>
